export default "<button pButton class=\"btn btn-primary\" type=\"button\" label=\"{{caption}}\" class=\"p-button-text\" (click)=\"add()\"></button>";